import React from 'react';

interface BuildingDocumentsProps {
  buildingId: string;
}

const BuildingDocuments: React.FC<BuildingDocumentsProps> = ({ buildingId }) => {
  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-medium text-gray-900">Documents</h3>
        <button
          type="button"
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none"
        >
          Upload Document
        </button>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <p className="p-4 text-center text-gray-500">No documents have been uploaded yet.</p>
      </div>
    </div>
  );
};

export default BuildingDocuments;
